// Costco Same-Day (sameday.costco.com, run by Instacart): there is no cart link, so each
// Costco line opens its product page (when matched) or a search, and is added by hand.
// Signed out, the site asks to sign in first and then continues to the page (?next=).

const COSTCO_SAMEDAY = 'https://sameday.costco.com';
const PRODUCT_HOSTS = /^(?:sameday\.costco\.com|(?:www\.)?instacart\.com)$/i;
const PRODUCT_PATH = /^\/(?:items\/[\w-]+|(?:store\/[\w-]+\/)?products\/[\w-]+)\/?$/i;

export function costcoSameDaySearchUrl(query: string): string {
  return `${COSTCO_SAMEDAY}/store/costco/s?k=${encodeURIComponent(query)}`;
}

/**
 * A product page pasted from Costco Same-Day (or the Costco store on instacart.com), cleaned
 * of tracking parameters. Undefined when the text isn't such a link.
 */
export function costcoProductUrl(input: string): string | undefined {
  const s = input.trim();
  if (!/^https?:\/\//i.test(s) && !/^(?:sameday\.costco\.com|(?:www\.)?instacart\.com)\//i.test(s)) return undefined;
  let url: URL;
  try {
    url = new URL(/^https?:\/\//i.test(s) ? s : `https://${s}`);
  } catch {
    return undefined;
  }
  if (!PRODUCT_HOSTS.test(url.hostname) || !PRODUCT_PATH.test(url.pathname)) return undefined;
  return `https://${url.hostname.toLowerCase()}${url.pathname.replace(/\/$/, '')}`;
}

/** Whether pasted text looks like a web link at all (so a wrong one can be refused). */
export function looksLikeUrl(input: string): boolean {
  return /^(?:https?:\/\/|www\.)|^[\w-]+(?:\.[\w-]+)+\//i.test(input.trim());
}
